module.exports = __webpack_public_path__ + "title_line.309711be.png";